module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iV3Qs"))).then(() => parcelRequire('d0iPb'));